
import { createRoot } from 'react-dom/client'
import { SplashScreen } from '@capacitor/splash-screen';
import App from './App.tsx'
import './index.css'

// Hide the splash screen when the app is ready
document.addEventListener('DOMContentLoaded', () => {
  SplashScreen.hide();
});

createRoot(document.getElementById("root")!).render(<App />);
